import React from 'react';
import PropTypes from 'prop-types';
import {
  Main,
} from './Loader.styles';

const Loader = ({ width, height }) => {
  return <Main width={width} height={height} />;
};

Loader.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Loader.defaultProps = {
  width: 150,
  height: 150,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loaders/Loader/Loader.jsx